import Palette from './palette'
import Color from 'color'

export const BTN_STYLES = {
  btn: {
    borderRadius: 5,
    fontFamily: '"brandon-grotesque", sans-serif !important',
    cursor: 'pointer',
    padding: '10px 36px 9px',
    letterSpacing: 1.3,
    color: Palette.SUNSTONE,
    fontSize: 20,
    lineHeight: '19px',
    textTransform: 'uppercase',
    textDecoration: 'none'
  },
  cta: {
    backgroundColor: Palette.LIGHTEST_PINK,
    borderRadius: 6,
    padding: '14px 44px 13px',
    marginTop: 0,
    marginRight: 20,
    marginBottom: 0,
    marginLeft: 3,
    boxShadow: 'rgba(0, 0, 0, 0.05) 0px 10px 30px 8px',
    transition: 'all 230ms cubic-bezier(0.45, 0.38, 0.43, 0.98)',
    ':hover': {
      boxShadow: 'rgba(0, 0, 0, 0.13) 0px 10px 30px 8px',
      transform: 'scale(1.01)',
      opacity: 1
    },
    ':active': {
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 30px 8px',
      transform: 'scale(.98)'
    }
  },
  ctaSecondary: {
    backgroundColor: Color(Palette.SUNSTONE).fade(.8)
  }
}


// WEBPACK FOOTER //
// ./src/components/assets/btns-shared.js